<template>
  <div class="page-wrapper">
    <div class="card bg-white- border-0 rounded-3 mb-1">
      <div class="card-body p-0">
        <!-- Improved Horizontal Calendar -->
        <div class="month-select-wrapper">
          <select v-model="selectedMonthYear" @change="handleMonthChange" class="custom-select">
            <option v-for="(option, index) in monthOptions" :key="index" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
        <div class="calendar-wrapper">
          <div class="calendar-center-frame"></div>

          <div class="horizontal-calendar-container" ref="calendarScroll" @scroll.passive="handleScrollEnd">
            <div class="horizontal-calendar" ref="calendarContainer">
              <div
                  v-for="day in visibleDays"
                  :key="day.date"
                  class="calendar-day"
                  :class="{
                'active': isActiveDay(day.date),
                'has-future-task': hasFutureTasks(day.date)
              }"
                  @click="selectDay(day.date)"
              >
                <div class="day-name">{{ day.dayName }}</div>
                <div class="day-number">{{ day.dayNumber }}</div>
                <div v-if="hasFutureTasks(day.date)" class="task-indicator"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="default-table-area style-two all-projects">
          <div class="container- py-1 px-4-" style="margin-top: -50px;">

            <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 p-4">
              <!--              <h2 class="mb-3 text-dark">Задачи</h2>-->
            </div>

            <div class="mb-4" style="display: none">
              <input
                  type="text"
                  ref="datePicker"
                  class="form-control bg-white text-dark border"
                  placeholder="Выберите дату"
              />
            </div>

            <!-- Add Task -->
            <div class="add-task-container mb-4 shadow-sm">
              <div class="d-flex flex-column flex-md-row gap-2">
                <input
                    v-model="newTask"
                    @keyup.enter="addTask"
                    type="text"
                    class="form-control bg-white text-dark border"
                    placeholder="Добавьте задачу"
                />

                <select v-model="newTaskType" class="form-control bg-white text-dark border">
                  <option value="основная">Основная</option>
                  <option value="срочная">Срочная</option>
                </select>

                <select
                    @change="loadAllTasks"
                    v-model="listQuery.user" class="form-control bg-white- text-dark border">
                  <option value="0">Все</option>
                  <option v-for="user in userList" :key="user.id" :value="user.id">
                    {{ user.name }}
                  </option>
                </select>

                <button
                    class="btn btn-primary" type="button" @click="addTask"
                    :disabled="loading || listQuery.user=='0'">
                  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <i v-else class="bi bi-plus"></i> Добавить
                </button>
              </div>
            </div>

            <!-- Tasks List -->
            <div class="card bg-white- border mb-4 shadow-sm">
              <div class="card-body p-0">
                <ul v-if="!loadingTasks" class="list-group list-group-flush">
                  <li
                      v-for="(task, index) in filteredTasks"
                      :key="task.id"
                      class="list-group-item bg-white text-dark border-bottom position-relative-"
                      :class="{ 'active-task': task.selected }"
                  >
                    <div class="d-flex align-items-start justify-content-between">
                      <div class="flex-grow-1">
                        <div
                            class="py-2 task-content"
                            @click="selectTask(task.id)"
                        >
                          <div class="d-flex flex-column">
                            <div class="d-flex justify-content-between- align-items-start">
                              <div class="form-check- pe-2 m-0">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :checked="task.status === 1"
                                    @change="updateTaskStatus(task)"
                                    @click.stop
                                    :id="'task-' + task.id"
                                />
                              </div>

                              <div
                                  class="form-check-label mb-0"
                                  :for="'task-' + task.id"
                                  :class="{
                                'text-decoration-line-through text-muted': task.status === 1,
                                'text-dark': task.status !== 1
                              }"
                              >
                                   <span v-if="editableTask===task.id">
                                  <input class="form-control"
                                         type="text"
                                         v-model="task.title"
                                         @focus="handleFocus"
                                         @blur="handleBlur"
                                         @input="checkForUnsavedChanges"
                                  >
                                  <div style="position:relative;left:10px" class="d-flex gap-2 mt-2">
                                    <button
                                        class="btn btn-sm btn-primary"
                                        @click="updateTaskTitle(task)"
                                    >
                                      Сохранить
                                    </button>
                                    <button
                                        class="btn btn-sm btn-outline-secondary"
                                        @click="editableTask=null"
                                    >
                                      Отменить
                                    </button>
                                  </div>
                                  <br/>
                                  </span>
                                <span v-else>
                                  {{ task.title }}
                                         <span
                                             v-if="task.comments && task.comments.length > 0"
                                             class="comment-count"
                                             :class="{'unread-comments': unreadComments[task.id] > 0}"
                                         >
                                  ({{ task.comments.length }})
                                  <span
                                      v-if="unreadComments[task.id] > 0"
                                      class="unread-dot" title="Непрочитанные комментарии"
                                  ></span>
                                </span>
                                </span>


                              </div>
                              <div class="d-flex">

                              </div>
                            </div>
                            <div class="d-flex align-items-center flex-wrap gap-2 mt-1">
                            <span class="badge" :class="getTaskTypeClass(task.task_type)">
                              {{ task.task_type || 'основная' }}
                            </span>
                              <span class="badge" :class="task.author_id === 1 ? 'bg-info' : 'bg-info'">
                                {{ task.author_id === 1 ? 'Гранд Админ' : task.user.name }}
                             </span>
                              <span v-if="task.author_id !== task.user_id" class="badge bg-primary">
                              {{ task.user.name }}
                             </span>

                              <span
                                  v-if="getDaysOverdue(task) > 0"
                                  class="badge bg-warning text-dark"
                                  title="Задача переносится"
                              >
                           +{{ getDaysOverdue(task) }} дн.
                          </span>

                              <div class="d-flex flex-column gap-1 mt-2 ms-4" style="font-size: 0.85rem;">
                                <div class="d-flex align-items-center">
                                  <i class="bi bi-calendar-event me-2 text-muted" style="font-size: 0.9rem;"></i>
                                  <span class="text-muted">Создана: {{ formatDate(task.init_at) }}</span>
                                </div>
                                <div v-if="task.completed_at" class="d-flex align-items-center">
                                  <i class="bi bi-check-circle me-2 text-muted" style="font-size: 0.9rem;"></i>
                                  <span class="text-muted">Завершена: {{ formatDate(task.completed_at) }}</span>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <br/>
                        <!-- Comment Section - Expanded under the title -->
                        <div v-if="task.selected" class="task-comments-expanded">
                          <div class="comment-input-section">
                            <h6 class="comment-section-title">Комментарий</h6>
                            <textarea
                                v-model="selectedTask.comment"
                                @focus="handleFocus"
                                @blur="handleBlur"
                                @input="checkForUnsavedChanges"
                                class="comment-textarea"
                                rows="4"
                                placeholder="Введите комментарий..."
                            ></textarea>
                            <button
                                class="btn btn-primary save-comment-btn"
                                @click="saveComment"
                                :disabled="!selectedTask.comment.trim() || loading"
                            >
                              <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                              <i v-else class="bi bi-save"></i> Сохранить комментарий
                            </button>
                          </div>

                          <div v-if="selectedTask.comments && selectedTask.comments.length"
                               class="comment-history-section">
                            <h6 class="comment-section-title" style="margin-top: 10px;">История комментариев</h6>
                            <div
                                class="comment-history-container scroll-container"
                                @touchstart="lockPageScroll"
                                @touchmove="lockPageScroll"
                            >
                              <!--                              @wheel.prevent="handleScroll"-->
                              <div
                                  v-for="(comment, idx) in selectedTask.comments"
                                  :key="idx"
                                  class="comment-item"
                              >
                                <div class="comment-header">
                                  <small class="comment-date">{{ formatDateTime(comment.created_at) }} </small>
                                  <small class="comment-date"> &nbsp; &nbsp;
                                    <i>({{ comment.user ? comment.user.name : authStore.user.name }})</i></small>
                                </div>
                                <p class="comment-text">{{ comment.comment }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                          class="edit-button border-0 bg-transparent flex-shrink-0"
                          @click.stop="editTask(task.id)"
                      >
                        <i class="material-symbols-outlined text-primary">edit</i>
                      </button>
                      <button
                          class="delete-button border-0 bg-transparent flex-shrink-0"
                          @click.stop="deleteTask(task.id)"
                      >
                        <i class="material-symbols-outlined text-danger">delete</i>
                      </button>

                    </div>
                  </li>
                </ul>
                <div v-else class="text-center p-4">
                  <div class="spinner-border text-primary"></div>
                  <p class="mt-2">Загрузка задач...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import {Russian} from "flatpickr/dist/l10n/ru.js";
import {fetchList, createTask, updateTask, deleteTask, storeTaskComment} from '@/api/task';
import {useAuthStore} from "@/stores/auth";
import UserResource from '@/api/user';

const userResource = new UserResource();

export default {
  name: "DayTasks",
  data() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const days = [];
    const availableMonths = [];

    // Generate 2 years of dates
    for (let i = -365; i <= 365; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      days.push(date);
    }

    // Generate available months for dropdown
    const currentYear = today.getFullYear();
    for (let year = currentYear - 1; year <= currentYear + 1; year++) {
      for (let month = 0; month < 12; month++) {
        availableMonths.push({
          value: new Date(year, month, 1).getTime(),
          label: new Date(year, month, 1).toLocaleDateString('ru-RU', {month: 'long', year: 'numeric'})
        });
      }
    }

    return {
      selectedMonthYear: "",
      scrollTimeout: null,
      monthOptions: [],
      selectedDate: today,
      visibleDays: [],
      isTransitioning: false,
      transitionDirection: null,
      months: [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      selectedMonth: today.getMonth(),
      selectedYear: today.getFullYear(),
      currentDate: new Date(today),
      days,
      availableMonths,
      selectedMonthTimestamp: new Date(today.getFullYear(), today.getMonth(), 1).getTime(),

      translateX: 0,
      isDragging: false,
      startX: 0,
      currentX: 0,
      activeIndex: 365,  // today
      itemWidth: 56,     // 48px + 8px gap
      transition: 'transform 0.1s ease-out',
      velocity: 0,
      lastTime: 0,
      lastX: 0,
      animationId: null,

      // Existing data
      isInputFocused: false,
      originalTaskComments: {}, // Track original comments
      originalTaskTitles: {},   // Track original titles
      tasksWithUnsavedChanges: new Set(), // Track which tasks have unsaved changes
      taskPollingInterval: null, // store interval ID
      editableTask: null,
      userList: null,
      authStore: useAuthStore(),
      currentUserId: null,
      readComments: JSON.parse(localStorage.getItem('readComments') || '{}'),
      newTask: "",
      newTaskType: "основная",
      //selectedDate: new Date(today),
      tasks: [],
      allTasks: [], // Store all tasks for filtering
      loading: false,
      loadingTasks: false,
      listQuery: {
        search: '',
        user: '0',
      },
    };
  },

  computed: {
    currentMonthYear() {
      const months = [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ];
      return `${months[this.selectedDate.getMonth()]} ${this.selectedDate.getFullYear()}`;
    },
    monthsWithYears() {
      const now = new Date();
      return this.months.map((month, index) => {
        const year = index === now.getMonth() ? now.getFullYear() : this.selectedYear;
        return `${month} ${year}`;
      });
    },
    unreadComments() {
      const unread = {};
      this.tasks.forEach(task => {
        if (task.comments && task.comments.length) {
          const lastReadTime = this.readComments[task.id] || 0;
          unread[task.id] = task.comments.filter(comment => {
            const commentTime = new Date(comment.created_at).getTime();
            return commentTime > lastReadTime;
          }).length;
        }
      });
      return unread;
    },
    selectedTask() {
      return this.tasks.find((task) => task.selected);
    },
    filteredTasks() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const isTodaySelected = this.selectedDate.toDateString() === today.toDateString();

      return this.tasks.filter(task => {
        const taskDate = new Date(task.date);
        taskDate.setHours(0, 0, 0, 0);

        // Show tasks for selected date
        if (taskDate.toDateString() === this.selectedDate.toDateString()) {
          return true;
        }

        // Show overdue tasks if today is selected
        if (isTodaySelected && taskDate < today) {
          return true;
        }

        return false;
      });
    }
  },

  mounted() {
    this.getUserList();
    this.currentUserId = this.authStore.user.id;
    this.initDatePicker();
    this.loadAllTasks();
    this.centerDay(this.activeIndex);
    this.loadSearchTerm();
    this.startStoragePolling();

    document.documentElement.style.overflowX = 'hidden';
    document.body.style.overflowX = 'hidden';

    this.checkOverflow = () => {
      if (document.documentElement.scrollWidth > window.innerWidth) {
        document.documentElement.style.overflowX = 'hidden';
      }
    };

    window.addEventListener('resize', this.checkOverflow);

    // 🔁 Auto-reload tasks every 20 seconds
    this.taskPollingInterval = setInterval(async () => {
      if (this.shouldPauseUpdates()) {
        console.log('Skipping auto-update - form has focus or unsaved changes');
        return;
      }

      try {
        const response = await fetchList(this.listQuery);

        // Create a map of new tasks for quick lookup
        const newTasksMap = new Map();
        response.tasks.forEach(task => {
          newTasksMap.set(task.id, {
            id: task.id,
            title: task.title,
            status: task.status,
            completed_at: task.completed_at,
            starred: task.starred || false,
            comment: task.comment || "",
            comments: task.comments || [],
            date: new Date(task.created_at),
            init_at: new Date(task.init_at),
            selected: false,
            task_type: task.task_type || 'основная',
            user_id: task.user_id,
            user: task.user || {name: 'Неизвестно'},
            author_id: task.author_id
          });
        });

        // Preserve selection state and merge with new data
        this.allTasks = this.allTasks.map(existingTask => {
          if (newTasksMap.has(existingTask.id)) {
            const updatedTask = newTasksMap.get(existingTask.id);
            // Preserve selected state
            updatedTask.selected = existingTask.selected;
            newTasksMap.delete(existingTask.id);
            return updatedTask;
          }
          return existingTask;
        });

        // Add any completely new tasks
        newTasksMap.forEach(task => {
          this.allTasks.push(task);
        });

        // Remove tasks that no longer exist
        const existingIds = new Set(response.tasks.map(t => t.id));
        this.allTasks = this.allTasks.filter(task => existingIds.has(task.id));

        this.updateTasksForSelectedDate();

      } catch (error) {
        console.error('Ошибка загрузки задач:', error);
      }
    }, 20000);
    this.generateVisibleDays();
    this.generateMonthOptions();
    this.selectedMonthYear = this.getMonthYearValue(this.selectedDate);
    this.$nextTick(() => this.scrollToDate(this.selectedDate, false));
  },

  beforeUnmount() {
    // 🧹 Clear interval and event listeners
    if (this.taskPollingInterval) {
      clearInterval(this.taskPollingInterval);
    }

    window.removeEventListener('resize', this.checkOverflow);
  },

  methods: {
    generateVisibleDays() {
      const centerDate = new Date();
      centerDate.setHours(0, 0, 0, 0);
      const days = [];

      for (let i = -400; i <= 400; i++) {
        const date = new Date(centerDate);
        date.setDate(centerDate.getDate() + i);

        days.push({
          date,
          dayName: date.toLocaleDateString("ru-RU", {weekday: "short"}),
          dayNumber: date.getDate(),
        });
      }

      this.visibleDays = days;
    },
    generateMonthOptions() {
      const options = new Set();

      this.visibleDays.forEach(({date}) => {
        const value = this.getMonthYearValue(date);
        const label = date.toLocaleDateString("ru-RU", {
          month: "long",
          year: "numeric",
        }).replace(/^./, c => c.toUpperCase());

        options.add(JSON.stringify({value, label}));
      });

      this.monthOptions = Array.from(options).map(item => JSON.parse(item));
    },
    getMonthYearValue(date) {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
    },
    scrollToDate(date, smooth = true) {
      const container = this.$refs.calendarScroll;
      const index = this.visibleDays.findIndex(
          d => d.date.toDateString() === date.toDateString()
      );
      if (index === -1 || !container) return;

      const dayWidth = 56;
      const scrollX = index * dayWidth - container.clientWidth / 2 + dayWidth / 2;
      container.scrollTo({left: scrollX, behavior: smooth ? "smooth" : "auto"});
    },
    handleMonthChange() {
      const [year, month] = this.selectedMonthYear.split("-");
      const targetDate = new Date(year, month - 1, 1);
      targetDate.setHours(0, 0, 0, 0);
      this.selectedDate = targetDate;
      this.scrollToDate(targetDate, true);
      this.updateTasksForSelectedDate();
    },
    handleScrollEnd() {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        const container = this.$refs.calendarScroll;
        const calendar = this.$refs.calendarContainer;
        const containerRect = container.getBoundingClientRect();
        const centerX = containerRect.left + container.clientWidth / 2;

        let closestDay = null;
        let minDistance = Infinity;

        Array.from(calendar.children).forEach((child, index) => {
          const rect = child.getBoundingClientRect();
          const center = rect.left + rect.width / 2;
          const dist = Math.abs(centerX - center);

          if (dist < minDistance) {
            minDistance = dist;
            closestDay = this.visibleDays[index];
          }
        });

        if (closestDay) {
          this.selectedDate = closestDay.date;
          this.selectedMonthYear = this.getMonthYearValue(closestDay.date);
        }
      }, 100);
    },
    selectDay(date) {
      this.selectedDate = date;
      this.selectedMonthYear = this.getMonthYearValue(date);
      this.scrollToDate(date, true);
      this.updateTasksForSelectedDate();
    },
    isActiveDay(date) {
      return date.toDateString() === this.selectedDate.toDateString();
    },


    isDayScaled(date) {
      return this.scaledDay && this.scaledDay.toDateString() === date.toDateString();
    },
    setScaledDay(date) {
      this.scaledDay = date;
    },


    // Calendar methods
    formatDayName(date) {
      return date.toLocaleDateString('ru-RU', {weekday: 'short'});
    },

    isCurrentMonth(timestamp) {
      const date = new Date(timestamp);
      const today = new Date();
      return date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
    },

    startDrag(e) {
      this.isDragging = true;
      this.transition = 'none';
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      this.startX = clientX;
      this.currentX = clientX;
      this.lastX = clientX;
      this.lastTime = performance.now();
      this.velocity = 0;

      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }

      // Prevent text selection during drag on desktop
      if (e.type === 'mousedown') {
        e.preventDefault();
      }
    },

    onDrag(e) {
      if (!this.isDragging) return;

      const now = performance.now();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const delta = clientX - this.currentX;

      // Calculate velocity for momentum scrolling
      if (now > this.lastTime) {
        this.velocity = (clientX - this.lastX) / (now - this.lastTime) * 10;
        this.lastX = clientX;
        this.lastTime = now;
      }

      this.currentX = clientX;

      // Use requestAnimationFrame for smoother updates
      if (!this.animationId) {
        this.animationId = requestAnimationFrame(() => {
          this.translateX += delta;
          this.animationId = null;
        });
      }
    },

    stopDrag() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.transition = 'transform 0.3s cubic-bezier(0.2, 0, 0.2, 1)';

      // Apply momentum if velocity is high enough
      if (Math.abs(this.velocity) > 0.5) {
        const momentumDistance = this.velocity * 50;
        this.translateX += momentumDistance;

        // Still snap to nearest item after momentum
        setTimeout(() => {
          this.snapToClosest();
        }, 300);
      } else {
        this.snapToClosest();
      }
    },

    snapToClosest() {
      const wrapperWidth = this.$el.querySelector('.horizontal-calendar-container').offsetWidth;
      const center = wrapperWidth / 2;
      const totalOffset = -this.translateX + center - this.itemWidth / 2;
      let nearestIndex = Math.round(totalOffset / this.itemWidth);

      nearestIndex = Math.max(0, Math.min(this.days.length - 1, nearestIndex));
      this.activeIndex = nearestIndex;
      this.centerDay(nearestIndex);

      // Update selected date
      this.selectedDate = new Date(this.days[nearestIndex]);
      this.loadTasksForDate(this.selectedDate);

      // Update selected month in dropdown
      this.selectedMonthTimestamp = new Date(
          this.days[nearestIndex].getFullYear(),
          this.days[nearestIndex].getMonth(),
          1
      ).getTime();
    },

    centerDay(index) {
      const wrapperWidth = this.$el.querySelector('.horizontal-calendar-container').offsetWidth;
      const newTranslateX = -(index * this.itemWidth) + wrapperWidth / 2 - this.itemWidth / 2;

      // Only update if position changed significantly to avoid micro movements
      if (Math.abs(this.translateX - newTranslateX) > 2) {
        this.translateX = newTranslateX;
      }
    },


    jumpToMonth() {
      const selectedDate = new Date(this.selectedMonthTimestamp);
      // Find the closest day in this month
      let closestIndex = 0;
      let minDiff = Infinity;

      this.days.forEach((day, index) => {
        const diff = Math.abs(day.getTime() - selectedDate.getTime());
        if (diff < minDiff) {
          minDiff = diff;
          closestIndex = index;
        }
      });

      this.selectDay(closestIndex);
    },


    hasFutureTasks(day) {
      return this.allTasks.some(task => {
        const taskDate = new Date(task.date);
        return (
            taskDate.toDateString() === day.toDateString() &&
            task.status !== 1
        );
      });
    },

    // Existing methods
    async updateCalendarForMonth() {
      const now = new Date();
      const isCurrentMonth = (
          this.selectedMonth === now.getMonth() &&
          this.selectedYear === now.getFullYear()
      );

      if (isCurrentMonth) {
        // For current month - show current week with today selected
        this.currentDate = new Date(now);
        this.selectDay(now);
      } else {
        // For other months - show first week with first day selected
        this.currentDate = new Date(this.selectedYear, this.selectedMonth, 1);
        this.selectDay(new Date(this.selectedYear, this.selectedMonth, 1));
      }

      try {
        this.listQuery.selectedMonth = this.selectedMonth;
        this.listQuery.selectedYear = this.selectedYear;
        const response = await fetchList(this.listQuery);

        // Create a map of new tasks for quick lookup
        const newTasksMap = new Map();
        response.tasks.forEach(task => {
          newTasksMap.set(task.id, {
            id: task.id,
            title: task.title,
            status: task.status,
            completed_at: task.completed_at,
            starred: task.starred || false,
            comment: task.comment || "",
            comments: task.comments || [],
            date: new Date(task.created_at),
            init_at: new Date(task.init_at),
            selected: false,
            task_type: task.task_type || 'основная',
            user_id: task.user_id,
            user: task.user || {name: 'Неизвестно'},
            author_id: task.author_id
          });
        });

        // Preserve selection state and merge with new data
        this.allTasks = this.allTasks.map(existingTask => {
          if (newTasksMap.has(existingTask.id)) {
            const updatedTask = newTasksMap.get(existingTask.id);
            // Preserve selected state
            updatedTask.selected = existingTask.selected;
            newTasksMap.delete(existingTask.id);
            return updatedTask;
          }
          return existingTask;
        });

        // Add any completely new tasks
        newTasksMap.forEach(task => {
          this.allTasks.push(task);
        });

        // Remove tasks that no longer exist
        const existingIds = new Set(response.tasks.map(t => t.id));
        this.allTasks = this.allTasks.filter(task => existingIds.has(task.id));

        this.updateTasksForSelectedDate();

      } catch (error) {
        console.error('Ошибка загрузки задач:', error);
      }
    },

    handleFocus() {
      this.isInputFocused = true;
    },

    handleBlur() {
      this.isInputFocused = false;
    },

    checkForUnsavedChanges() {
      if (this.selectedTask) {
        // Check comment changes
        const hasCommentChanges = this.selectedTask.comment.trim() !==
            (this.originalTaskComments[this.selectedTask.id] || '').trim();

        // Check title changes (if you're tracking them)
        const hasTitleChanges = this.selectedTask.title.trim() !==
            (this.originalTaskTitles[this.selectedTask.id] || '').trim();

        // Update the Set of tasks with unsaved changes
        if (hasCommentChanges || hasTitleChanges) {
          this.tasksWithUnsavedChanges.add(this.selectedTask.id);
        } else {
          this.tasksWithUnsavedChanges.delete(this.selectedTask.id);
        }

        return hasCommentChanges || hasTitleChanges;
      }
      return false;
    },

    async getUserList() {
      console.log('list u');
      this.loading = true;
      const {data, meta} = await userResource.list();
      this.userList = data;
      this.total = meta.total;
      this.loading = false;
    },
    markCommentsAsRead(taskId) {
      const now = new Date().getTime();
      this.readComments = {
        ...this.readComments,
        [taskId]: now
      };
      localStorage.setItem('readComments', JSON.stringify(this.readComments));
    },

    async loadAllTasks() {
      try {
        this.loadingTasks = true;
        const response = await fetchList(this.listQuery);

        this.allTasks = response.tasks.map(task => ({
          id: task.id,
          title: task.title,
          status: task.status,
          completed_at: task.completed_at,
          starred: task.starred || false,
          comment: task.comment || "",
          comments: task.comments || [],
          date: new Date(task.created_at),
          init_at: new Date(task.init_at),
          selected: false,
          task_type: task.task_type || 'основная',
          user_id: task.user_id,
          author_id: task.author_id,
          user: task.user || {name: 'Неизвестно'}
        }));

        this.updateTasksForSelectedDate();

      } catch (error) {
        console.error('Ошибка загрузки задач:', error);
      } finally {
        this.loadingTasks = false;
      }
    },

    updateTasksForSelectedDate() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const isTodaySelected = this.selectedDate.toDateString() === today.toDateString();

      // Updated helper function to sort tasks with completed tasks last
      const sortTasks = (a, b) => {
        // Both completed - sort by completion date (newest first)
        if (a.status === 1 && b.status === 1) {
          return new Date(b.completed_at) - new Date(a.completed_at);
        }
        // Only A is completed - B comes first
        if (a.status === 1) return 1;
        // Only B is completed - A comes first
        if (b.status === 1) return -1;

        // Both are urgent - sort by date (newest first)
        if (a.task_type === 'срочная' && b.task_type === 'срочная') {
          return new Date(b.date || b.completed_at) - new Date(a.date || a.completed_at);
        }
        // Only A is urgent
        if (a.task_type === 'срочная') return -1;
        // Only B is urgent
        if (b.task_type === 'срочная') return 1;
        // Neither is urgent - sort by date (newest first)
        return new Date(b.date || b.completed_at) - new Date(a.date || a.completed_at);
      };

      if (this.listQuery.search) {
        // When searching, show all matching tasks with completed last
        this.tasks = [...this.allTasks]
            .filter(task => true)
            .sort(sortTasks);
      } else if (isTodaySelected) {
        // 1. Today's tasks (planned for today)
        const todayTasks = this.allTasks.filter(task => {
          const taskDate = new Date(task.date);
          taskDate.setHours(0, 0, 0, 0);
          return taskDate.toDateString() === this.selectedDate.toDateString();
        });

        // 2. Overdue tasks (incomplete tasks from past dates)
        const overdueTasks = this.allTasks.filter(task => {
          const taskDate = new Date(task.date);
          taskDate.setHours(0, 0, 0, 0);
          return task.status !== 1 && taskDate < today;
        });

        // 3. Tasks completed today (regardless of their original date)
        const completedTodayTasks = this.allTasks.filter(task => {
          if (task.completed_at) {
            const completedDate = new Date(task.completed_at);
            completedDate.setHours(0, 0, 0, 0);
            return completedDate.toDateString() === today.toDateString();
          }
          return false;
        });

        // Combine all (avoid duplicates if any) and sort with completed last
        const uniqueTasks = [...todayTasks, ...overdueTasks, ...completedTodayTasks]
            .filter((task, index, self) =>
                index === self.findIndex(t => t.id === task.id)
            )
            .sort(sortTasks);

        this.tasks = uniqueTasks;
      } else {
        // For other dates - show tasks for that date with completed last
        this.tasks = this.allTasks
            .filter(task => {
              const taskDate = new Date(task.date);
              taskDate.setHours(0, 0, 0, 0);
              return taskDate.toDateString() === this.selectedDate.toDateString();
            })
            .sort(sortTasks);
      }

      console.log('Filtered and sorted tasks (completed last):', this.tasks);
    },

    async loadTasksForDate(date) {
      this.selectedDate = new Date(date);
      this.updateTasksForSelectedDate();
    },

    getDaysOverdue(task) {
      const createdDate = new Date(task.date);

      // For completed tasks, use completed_at if available, otherwise use today
      const endDate = task.status === 1 && task.completed_at
          ? new Date(task.completed_at.replace(' ', 'T'))
          : new Date();

      // Reset time components to compare just dates
      createdDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      // Calculate difference in days
      const diffTime = endDate - createdDate;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

      return diffDays > 0 ? diffDays : 0;
    },

    getTaskTypeClass(taskType) {
      return taskType === 'срочная' ? 'bg-danger' : 'bg-secondary';
    },

    scrollToDetails() {
      this.$nextTick(() => {
        if (this.selectedTask) {
          const element = document.querySelector(`[data-task-id="${this.selectedTask.id}"]`);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            });
          }
        }
      });
    },

    initDatePicker() {
      this.flatpickr = new Flatpickr(this.$refs.datePicker, {
        locale: Russian,
        defaultDate: this.selectedDate,
        dateFormat: "d.m.Y",
        onChange: async (selectedDates) => {
          this.selectedDate = selectedDates[0] || new Date();
          await this.loadTasksForDate(this.selectedDate);
        }
      });
    },

    formatDateForAPI(date) {
      return date.toISOString().split('T')[0];
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      });
    },

    formatDateTime(date) {
      return new Date(date).toLocaleString('ru-RU', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    loadSearchTerm() {
      this.listQuery.search = localStorage.getItem("searchTerm") || "";
    },

    handleStorageChange(event) {
      if (event.key === "searchTerm") {
        this.listQuery.search = event.newValue;
        this.loadTasks();
      }
    },

    startStoragePolling() {
      this.storagePollingInterval = setInterval(() => {
        const currentSearchTerm = localStorage.getItem("searchTerm") || "";
        if (currentSearchTerm !== this.listQuery.search) {
          this.listQuery.search = currentSearchTerm;
          this.loadTasks();
        }
      }, 500);
    },

    stopStoragePolling() {
      if (this.storagePollingInterval) {
        clearInterval(this.storagePollingInterval);
      }
    },

    async loadTasks() {
      await this.loadAllTasks();
    },

    async updateTaskTitle(task) {
      try {
        await updateTask({
          id: task.id,
          title: task.title
        });
      } catch (error) {
        console.error('Ошибка обновления:', error);
      }
      this.editableTask = null;
    },

    async updateTaskStatus(task) {
      try {
        const newStatus = task.status === 1 ? 0 : 1;
        task.status = newStatus;

        await updateTask({
          id: task.id,
          status: newStatus
        });

      } catch (error) {
        console.error('Ошибка обновления статуса:', error);
        task.status = task.status === 1 ? 0 : 1;
      }
    },

    async addTask() {
      const title = this.newTask.trim();
      if (!title) return;

      try {
        this.loading = true;
        const response = await createTask({
          title,
          status: 0,
          date: this.selectedDate,
          task_type: this.newTaskType,
          user_id: this.listQuery.user > 0 ? this.listQuery.user : this.authStore.user.id,
          author_id: this.authStore.user.id
        });

        await this.loadAllTasks();

        this.newTask = "";
        this.newTaskType = "основная";

        const taskDate = new Date(response.created_at || new Date()).toDateString();
        if (taskDate === this.selectedDate.toDateString()) {
          this.selectTask(response.id);
        }

      } catch (error) {
        console.error('Ошибка создания задачи:', error);
      } finally {
        this.loading = false;
      }
    },

    async toggleStar(task) {
      try {
        task.starred = !task.starred;
        await updateTask({
          id: task.id,
          starred: task.starred
        });
      } catch (error) {
        console.error('Ошибка обновления задачи:', error);
        task.starred = !task.starred;
      }
    },

    selectTask(taskId) {
      // Save current state before changing selection
      if (this.selectedTask) {
        this.originalTaskComments[this.selectedTask.id] = this.selectedTask.comment;
        this.originalTaskTitles[this.selectedTask.id] = this.selectedTask.title;
      }

      const task = this.tasks.find(t => t.id === taskId);
      const wasSelected = task.selected;

      // Toggle selection state
      this.tasks.forEach(t => {
        t.selected = t.id === taskId ? !wasSelected : false;
      });

      // Store original values when opening
      if (!wasSelected) {
        this.originalTaskComments[taskId] = task.comment || '';
        this.originalTaskTitles[taskId] = task.title || '';
      }

      // Mark comments as read when opening task
      if (!wasSelected && this.unreadComments[taskId] > 0) {
        this.markCommentsAsRead(taskId);
      }

      // Only scroll if we're expanding (not collapsing)
      if (!wasSelected) {
        this.$nextTick(() => {
          const element = document.querySelector(`[data-task-id="${taskId}"]`);
          if (element) {
            // Scroll to the top of the task element
            const topPos = element.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
              top: topPos - 20, // 20px offset from top
              behavior: 'smooth'
            });
          }
        });
      }
    },

    shouldPauseUpdates() {
      return this.isInputFocused || this.tasksWithUnsavedChanges.size > 0;
    },

    async saveComment() {
      if (!this.selectedTask.comment.trim()) return;

      try {
        this.loading = true;
        const newComment = {
          text: this.selectedTask.comment,
          comment: this.selectedTask.comment,
          date: new Date(),
          created_at: new Date(),
          user_id: this.currentUserId
        };

        this.selectedTask.comments = [newComment, ...(this.selectedTask.comments || [])];
        this.markCommentsAsRead(this.selectedTask.id);

        await storeTaskComment({
          task_id: this.selectedTask.id,
          comment: this.selectedTask.comment,
          comments: this.selectedTask.comments
        });

        // Update the original comment after successful save
        this.originalTaskComments[this.selectedTask.id] = this.selectedTask.comment;
        this.tasksWithUnsavedChanges.delete(this.selectedTask.id);
        this.selectedTask.comment = "";

      } catch (error) {
        console.error('Ошибка сохранения комментария:', error);
      } finally {
        this.loading = false;
      }
    },

    async editTask(taskId) {
      this.editableTask = taskId;
    },

    async deleteTask(taskId) {
      if (!confirm('Вы уверены, что хотите удалить эту задачу?')) return;

      const taskIndex = this.allTasks.findIndex(task => task.id === taskId);
      if (taskIndex === -1) return; // Task not found

      const backupTask = {...this.allTasks[taskIndex]}; // Backup in case of failure

      // Optimistically remove the task
      this.allTasks.splice(taskIndex, 1);
      this.updateTasksForSelectedDate();

      try {
        await deleteTask({id: taskId}); // API call
      } catch (error) {
        console.error('Ошибка удаления задачи:', error);
        // Revert if deletion fails
        this.allTasks.splice(taskIndex, 0, backupTask);
        this.updateTasksForSelectedDate();
        alert("Не удалось удалить задачу. Попробуйте снова.");
      }
    },

    lockPageScroll(e) {
      // Prevent page scrolling when scrolling comments
      if (e.currentTarget.scrollTop === 0 && e.deltaY < 0) {
        e.preventDefault();
      } else if (e.currentTarget.scrollHeight === e.currentTarget.scrollTop + e.currentTarget.clientHeight && e.deltaY > 0) {
        e.preventDefault();
      }
    }
  },

  beforeDestroy() {
    if (this.flatpickr) {
      this.flatpickr.destroy();
    }
    this.stopStoragePolling();
  }
};
</script>

<style scoped>
.page-wrapper {
  overflow: hidden;
}

.month-select-wrapper {
  text-align: center;
  /*  margin-top: 12px;*/
  margin-bottom: 5px;
}

.custom-select {
  padding: 6px 12px;
  border-radius: 8px;
  border: 0px solid #ccc;
  font-size: 16px;
  background-color: #f8f9fa;
  appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg fill='gray' height='20' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>");
  background-repeat: no-repeat;
  background-position-x: calc(100% - 12px);
  background-position-y: center;
  background-size: 16px;
}

.calendar-wrapper {
  position: relative;
  padding: 12px 0;
}

.calendar-center-frame {
  position: absolute;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  width: 48px;
  height: 64px;
  border-radius: 12px;
  pointer-events: none;
  z-index: 10;
}

.horizontal-calendar-container {
  overflow-x: auto;
  white-space: nowrap;
  padding: 0 12px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

.horizontal-calendar-container::-webkit-scrollbar {
  display: none;
}

.horizontal-calendar {
  display: inline-flex;
  gap: 8px;
  padding: 8px 0;
}

.calendar-day {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 64px;
  border-radius: 12px;
  background: transparent;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.calendar-day.active {
  font-weight: 600;
  color: #0d6efd;
  transform: scale(1.5);
}

.day-name {
  font-size: 12px;
  opacity: 0.8;
  text-transform: capitalize;
}

.day-number {
  font-size: 18px;
  font-weight: 600;
}

/* Масштабування при виборі */
.calendar-day.scale {
  transform: scale(1.2);
}


.material-symbols-outlined {
  font-size: 24px;
  color: #666;
  transition: color 0.2s;
}

.form-control {
  width: 95% !important;
  position: relative;
  left: 10px;
}

.active-task {
  background-color: rgba(13, 110, 253, 0.1) !important;
  border-left: 4px solid #0d6efd !important;
}

.task-content {
  cursor: pointer;
  flex-grow: 1;
}

.task-comments-section {
  border-top: 1px solid #eee;
  padding-top: 12px;
}

.comment-tree {
  max-height: 300px;
  overflow-y: auto;
}

.comment-tree::-webkit-scrollbar {
  width: 8px;
}

.comment-tree::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.comment-tree::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.comment-tree::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

.form-check-input {
  border: 1px solid #ced4da;
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-control:focus, .form-select:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.btn:disabled {
  opacity: 0.65;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.shadow-sm {
  box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
}

.add-task-container .form-select {
  min-width: 120px;
}

.badge {
  font-size: 0.75rem;
  font-weight: normal;
  white-space: nowrap;
}

.text-decoration-line-through {
  text-decoration: line-through;
}

.list-group-item {
  display: flex;
  align-items: flex-start;
}

@media (max-width: 767.98px) {
  .add-task-container .d-flex {
    flex-direction: column;
  }

  .add-task-container .form-select,
  .add-task-container .btn {
    width: 100%;
    margin-top: 8px;
  }

  .list-group-item {
    flex-direction: column;
  }

  .task-content {
    width: 100%;
    margin-bottom: 8px;
  }

  .d-flex.align-items-center.flex-wrap.gap-2 {
    margin-top: 4px;
  }
}


.task-indicator {
  position: relative;
  top: -43px;
  right: -20px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #dc3545;
}

.no-task-indicator {
  position: relative;
  top: -43px;
  right: -20px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}


/* Увеличенная секция комментариев */
.task-comments-expanded {
  width: 100%;
  margin-top: 16px;
  padding: 0;
}

.comment-input-section,
.comment-history-section {
  width: 100%;
  padding: 0;
}

.comment-section-title {
  font-size: 1.1rem;
  margin-bottom: 12px;
  color: #333;
}

.comment-textarea {
  width: 100%;
  min-height: 120px;
  padding: 12px;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: vertical;
}

.save-comment-btn {
  width: 100%;
  margin-top: 12px;
  padding: 10px;
  font-size: 1rem;
}

/* Увеличенная история комментариев */
.comment-history-container {
  width: 100%;
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 8px;
  -webkit-overflow-scrolling: touch;
}

.comment-item {
  width: 100%;
  padding: 16px;
  margin-bottom: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.comment-header {
  margin-bottom: 8px;
}

.comment-date {
  font-size: 0.85rem;
  color: #6c757d;
}

.comment-text {
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Улучшения для мобильных устройств */
@media (max-width: 768px) {
  .comment-history-container {
    max-height: 50vh;
    padding-bottom: 20px;
  }

  .comment-textarea {
    min-height: 150px;
  }

  .comment-item {
    padding: 12px;
  }
}

/* Кастомный скроллбар */
.comment-history-container::-webkit-scrollbar {
  width: 8px;
}

.comment-history-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.comment-history-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.comment-history-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.page-wrapper {
  max-width: 100%;
  overflow-x: hidden;
  position: relative;
}

/* Общие стили для максимальной ширины */
.task-container {
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0;
}

.task-card-wide {
  width: 100%;
  margin: 0;
  padding: 12px 4px;
  border-radius: 0;
  box-shadow: none;
  border: none;
}

.task-header {
  width: 100%;
  padding: 0 4px;
  margin-bottom: 16px;
}

.task-title {
  font-size: 1.4rem;
  margin: 0;
  padding: 0;
  width: 100%;
  word-break: break-word;
}

/* Форма комментария */
.comment-form-wide {
  width: 100%;
  padding: 0 4px;
  margin-bottom: 24px;
}

.comment-title {
  margin: 0 0 8px 0;
  padding: 0;
  font-size: 1.2rem;
}

.full-width-textarea {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  padding: 12px;
  margin: 0;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-sizing: border-box;
  min-height: 120px;
}

.save-btn-wide {
  width: 100%;
  margin: 12px 0 0 0;
  padding: 12px;
}

/* История комментариев */
.comment-history-wide {
  width: 100%;
  padding: 0 4px;
}

.history-title {
  margin: 0 0 8px 0;
  padding: 0;
  font-size: 1.2rem;
}

.scroll-container {
  width: 100%;
  max-height: 50vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
}

.comment-item-wide {
  width: 100%;
  padding: 12px 8px;
  margin-bottom: 12px;
  background: #f8f9fa;
  border-radius: 6px;
}

.comment-meta {
  margin-bottom: 6px;
}

.comment-date {
  font-size: 0.85rem;
  color: #666;
}

.comment-text {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;
}

/* Отключение скролла страницы при скролле комментариев */
body.scroll-locked {
  overflow: hidden;
  position: fixed;
  width: 100%;
}

.comment-count {
  font-size: 0.85em;
  color: #6c757d;
  margin-left: 4px;
  transition: color 0.2s;
}

.unread-comments {
  color: #dc3545;
  font-weight: bold;
}

.unread-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  background-color: #dc3545;
  border-radius: 50%;
  margin-left: 4px;
  vertical-align: middle;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

/* Add more spacing between task items */
.list-group-item {
  margin-bottom: 12px;
  border-radius: 8px !important;
  border: 1px solid #dee2e6 !important;
}

/* Optional: Add more padding inside each task card */
.list-group-item > .d-flex {
  padding: 12px 8px;
}

/* If you want to increase spacing specifically for the cards */
.card.bg-white.border.mb-4.shadow-sm {
  margin-bottom: 20px !important;
}

/* If you want to add spacing between the task content and comments */
.task-comments-expanded {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

/* Edit and Delete Buttons Styles */
.edit-button, .delete-button {
  position: absolute;
  padding: 0.5rem;
  opacity: 0.7;
  transition: all 0.2s ease;
  z-index: 1;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.edit-button {
  top: 8px;
  right: 8px;
}

.delete-button {
  bottom: 8px;
  right: 8px;
}

.edit-button:hover, .delete-button:hover {
  opacity: 1;
  transform: scale(1.1);
}

.delete-button:hover {
  background-color: rgba(220, 53, 69, 0.1) !important;
}

/* Make icons larger */
.edit-button i, .delete-button i {
  font-size: 20px !important;
}

/* Mobile specific styles */
@media (max-width: 768px) {
  .edit-button, .delete-button {
    width: 40px;
    height: 40px;
    padding: 0.75rem;
  }

  .edit-button i, .delete-button i {
    font-size: 24px !important;
  }
}
</style>

<style>
.form-check-input {
  width: 1.6em !important;
  height: 1.6em !important;
  margin-top: 0.1em !important;
}

/* Adjust clickable area (optional) */
.form-check {
  min-height: 1.6em;
}

.form-check-label {
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 4px;
}

/* Для завершенных задач сохраняем перечеркивание */
.form-check-label.text-decoration-line-through {
  text-decoration: line-through;
  opacity: 0.8;
}

@media (max-width: 768px) {
  .form-check-label {
    font-size: 1.05rem;
  }
}

.sidebar-hide .sidebar-area:hover {
  width: 140px !important;
}

@media only screen and (max-width: 1199px) {
  .sidebar-hide .sidebar-area {
    width: 170px !important;
    left: 0;
    box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
  }

  .calendar-wrapper {
    padding: 0px !important;
    margin-bottom: 5px;
  }
}
</style>